import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  articleList: undefined,
  articleTitle: '',
  articleId: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ARTICLE_LIST:
      return {
        ...state,
        isLoading: true,
        error: false,
        articleList: undefined,
      };
    case types.RECEIVE_ARTICLE_LIST:
      return {
        ...state,
        isLoading: false,
        error: false,
        articleList: action.payload.articleList,
        articleTitle: action.payload.articleTitle,
        articleId: action.payload.articleId,
      };
    case types.RECEIVE_ARTICLE_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        articleList: undefined,
        articleTitle: '',
        articleId: '',
      };
    default:
      return state;
  }
}
